import React from 'react'
import ReactDOM from 'react-dom/client'
import { ApolloProvider } from '@apollo/client'
import { client } from './apollo'
import { AppRoute } from './app/shared/Services/AppRoute'

import './index.scss'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <AppRoute></AppRoute>
    </ApolloProvider>
  </React.StrictMode>,
)
